import { useQuery } from '@apollo/client'
import { Button, Typography } from '@material-ui/core'
import { useState } from 'react'

import { LOGIN_HISTORIES_QUERY } from '../../graphql/auth'
import { formatLoginAttemptTime } from '../../helpers/date'
import { getTranslate } from '../../localization'
import { ActionLog } from '../../types/auth'
import useStyles from './styles/loginAttempts.styles'

export default function LoginAttempts() {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, loading: loadingForLoginHistory } = useQuery<{
    loginHistories: ActionLog[]
  }>(LOGIN_HISTORIES_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      successCount: 3,
      failedCount: 3
    }
  })

  const visibleItems = expanded
    ? data?.loginHistories
    : data?.loginHistories.slice(0, 3)

  const disabled = data && data?.loginHistories.length <= 3

  return (
    <div className={classes.root}>
      <div className={classes.firstItem}>
        <Typography className={classes.title}>
          {getTranslate('Recent login attempts')}
        </Typography>
        <Typography className={classes.subtitle}>
          {visibleItems?.length} {getTranslate('Last Login')}
        </Typography>
      </div>
      <div className={classes.itemsWrapper}>
        {visibleItems &&
          visibleItems.map((item, index) => (
            <div key={index} className={classes.item}>
              <div className={classes.row}>
                <Typography>{getTranslate('IP')}:</Typography>
                {/*
                  Stored login records can carry an empty IP: the gateway resolves the
                  client address behind a trusted-proxy check and, when that check fails,
                  it records "" rather than failing the request. Printing the raw value
                  left "IP:" followed by nothing, which reads as a broken row rather than
                  as an unknown address. Reported against this panel; the missing address
                  itself is a gateway-side gap, and a dash does not hide it.
                */}
                <Typography>{item.ip || '—'}</Typography>
                <Typography
                  className={
                    item.status === 'Success' ? classes.success : classes.failed
                  }>
                  {getTranslate(item.status)}
                </Typography>
              </div>
              <Typography className={classes.time}>
                {` ${getTranslate('Time')}: ${formatLoginAttemptTime(
                  item.time
                )}`}
              </Typography>
            </div>
          ))}
      </div>
      <div className={classes.lastItem}>
        <Button
          variant="text"
          color="primary"
          disabled={disabled}
          onClick={() => setExpanded(!expanded)}>
          <Typography
            className={[
              classes.viewAll,
              disabled && classes.viewAllDisabled
            ].join(' ')}>
            {expanded ? getTranslate('View Less') : getTranslate('View All')}
          </Typography>
        </Button>
      </div>
    </div>
  )
}
